module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921092649_T.8da8118c.jpg";